// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__yKsCu","brand":"Nav_brand__BPXb3"};